export class AuthorityTax {
    licenseNo: string;
    startDate: Date;
    endDate: Date;
    renewalDate: Date;
    taxAmount: number;
}